require('./genericFarmMap.global.pcss');

angular
  .module('cfn')
  .controller('genericFarmMapController', genericFarmMapController);

genericFarmMapController.$inject = [
  '$scope',
  '$rootScope',
  '$q',
  '$http',
  '$filter',
  '$location',
  '$dialog',
  '$injector',
  '$route',
  '$timeout',
  '$routeParams',
  'genericFarmMapService',
  'fnwNavigationService'
];
function genericFarmMapController(
  $scope,
  $rootScope,
  $q,
  $http,
  $filter,
  $location,
  $dialog,
  $injector,
  $route,
  $timeout,
  $routeParams,
  genericFarmMapService,
  fnwNavigationService
) {
  $scope.status = {
    sidebarVisible: true
  };

  var ctrl = this;

  ctrl.mapLeft = 389; // initial value should fit with tabs opened

  ctrl.fieldsTabActive = false;

  ctrl.inited = false;

  genericFarmMapService.checkPluginsEnabled();

  ctrl.pluginTabs = {};

  ctrl.getPlugins = function() {
    return genericFarmMapService.getPlugins();
  };

  ctrl.setPlugins = function(plugins) {
    ctrl.plugins = plugins;
  };

  ctrl.onMapInit = function() {
    // ctrl.mapLeft = jMap[0].offsetLeft;
    ctrl.inited = true;
  };

  ctrl.getCurrentPluginController = function() {
    if (ctrl.currentPlugin) {
      return ctrl.currentPlugin.controller;
    }
  };

  ctrl.setCurrentPlugin = function(plugin, update) {
    ctrl.currentPlugin = plugin;
    if (update) ctrl.updatePluginTabs();
  };

  ctrl.updatePluginTabs = function() {
    ctrl.fieldsTabActive = false;

    var plugins = ctrl.getPlugins();
    for (var i = 0; i < plugins.length; i++) {
      ctrl.pluginTabs[plugins[i].name] =
        ctrl.currentPlugin.name === plugins[i].name;
    }
  };

  /**
   * Method to be called if the current tab loses the focus >> clean up!
   */
  ctrl.onLostFocus = function(plugin) {
    if (plugin !== null && plugin !== undefined && plugin.onLostFocus) {
      plugin.onLostFocus();
    }
  };

  ctrl.cleanupTab = function(plugin) {
    if (plugin !== null && plugin !== undefined && plugin.cleanupTab) {
      plugin.cleanupTab();
    }
  };

  ctrl.fnwNavigateTo = function (clickEvent, url) {
    fnwNavigationService.navigateToServiceByUrl(url);
    clickEvent.preventDefault();
  };

  $scope.$watch('status.sidebarVisible', function() {
    $timeout(function() {
      ctrl.mapLeft = $('#map')[0].offsetLeft;
    });
  });

  $scope.switchToFields = function() {
    if (ctrl.inited) {
      // only allow switching to fields after init is done
      $location.path('farmMapTab/fields');
    }
  };

  $scope.ctrl = this;
  return this;
}
